import { GetDepartments } from "../services/financialService";
const requestDepartmentsType = "REQUEST_DEPARTMENTS";
const receiveDepartmentsType = "RECEIVE_DEPARTMENTS";
const initialState = { departments: [], loading: false };

export const actionCreators = {
  requestDepartments: () => async (dispatch, getState) => {
    let { departments } = getState().departments;
    if (departments && departments.length > 0) {
      return;
    }
    dispatch({ type: requestDepartmentsType });

    departments = await GetDepartments();

    dispatch({ type: receiveDepartmentsType, departments });
  }
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === requestDepartmentsType) {
    return {
      ...state,
      loading: true
    };
  }

  if (action.type === receiveDepartmentsType) {
    const { departments } = action;
    return {
      ...state,
      departments,
      loading: false
    };
  }

  return state;
};
